import React, {Component} from 'react';

import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {
    actionsFormatter,
  imagesFormatter,
    customFormatter,
} from 'util/Utils';
import classNames from 'classnames';
  import config from  '../../../config';


class AdminQualityChecksListTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            perPage: config.table.numberPerPage,
            currentRecord: {},

        };

    }

    customActionsFormatter(cell, row, extra) {
        var menuItemsMap = [
            {onClick: (row)=>{
                this.props.editRecord(row)
            }, label: 'Edit'},
            {onClick:(row)=>{
                this.props.showRemoveDialog(row)
            }, label: 'Delete'},
        ]


        return actionsFormatter.call(this, cell, row, {menuItemsMap})
    }

    editRecord(row) {
        this.props.editRecord(row);
    }
    formatModels(cell, row, extra){

        return <div >{_.map(_.get(row,  ['Models'], []), function (item, index) {


            var styles ={marginTop:5}
            if (_.get(row,  ['Models'], []).length !== index+1){
                styles.paddingBottom = 5;
                styles.borderBottom = '1px solid gray';
            }
            return <div style={styles} key={index}>
                <div className="green" >{item.Brand}</div>
                <div  style={{color:'orange'}}>{_.get(item,  'Model','')}</div>
            </div>

        }.bind(this) )}</div>
    }
  deleteImage(recordID, imageToDelete) {
     return this.props.makeRequest({QualityCheckImagesToDelete: [imageToDelete]}, {
      "endpoint": "/quality-checks/" + encodeURIComponent(recordID),
      type: "patch",
    }).then(res => {
      this.props.displayMessage({
        'messageCode': 'Image deleted',
      });
      let searchParams = {}
     if(this.props.currentPage > 1){
       searchParams.page = this.props.currentPage
     }
      this.props.search(searchParams)
      return true
    }).catch(err => {
    });
  }
  formatTextColumn(cell, row, columnIndex, rowIndex){
    const {Text = ''} = row

    return <div>
      <div className='bot10'>{Text}</div>
        {imagesFormatter.call(this,  row,  rowIndex,{
          displayMultipleImages:true,
          deleteImageHandler:(image) => {
             this.deleteImage(row._id, image)
            return Promise.resolve(true)
          },
           imagePath:   ['QualityCheckImages'],
          imageStyle:{width:110, height:110},
          total:this.props.total,
          perPage:this.state.perPage,
          currentPage:this.props.currentPage,
        } )}
     </div>
  }
    formatCategories(cell, row, extra){

        return <div >{_.map(_.get(row,  ['Categories'], []), function (item, index) {
            var foundCategory = _.find(this.props.allCategories, function (category) {
                return category.TagName ==item.Category
            })
            if (foundCategory){
                foundCategory = foundCategory.CategoryName
            } else{
                foundCategory = 'Category not found'
            }
            var foundSubCategory = ''
            if (item.Subcategory) {
                foundSubCategory = _.find(this.props.allCategories, function (category) {
                    return category.TagName == item.Subcategory
                })
                if (foundSubCategory){
                    foundSubCategory = foundSubCategory.CategoryName
                } else{
                    foundSubCategory = 'Subcategory not found'
                }

            } else{
                foundSubCategory = ''
            }
            var styles ={marginTop:5}
            if (_.get(row,  ['Categories'], []).length !== index+1){
                styles.paddingBottom = 5;
                styles.borderBottom = '1px solid gray';
            }
            return <div style={styles} key={index}>
                <div className="green" >{foundCategory}</div>
                <div  style={{color:'orange'}}>{foundSubCategory}</div>
            </div>

        }.bind(this) )}</div>
    }
    formatTags(cell, row, extra){

        return <div >{_.map(_.get(row,  [extra.field], []), function (item, index) {

            return <div style={{ }} key={index}>
                <div className="green" >{item}</div>
            </div>

        }.bind(this) )}</div>
    }





    render() {
          return (
            <div className=" databases-table">
                <BootstrapTable data={this.props.qualityChecks} ref='table'
                                remote={ true }
                                hover={true}
                                condensed={true}
                                striped={true}
                                options={ {
                                    ...config.bootstrapTableOptions,
                                    onSortChange: this.props.onSortChange
                                } }

                >
                    <TableHeaderColumn width="40px" dataField='ItemNumber'  dataFormat={ customFormatter }
                                       formatExtraData={ {
                                         path: ['getObject'],
                                         format: (row) => {
                                           const {DeterministicQualityCheck = {}} = row;
                                           return <div>
                                             <div>{row.ItemNumber}</div>
                                             {DeterministicQualityCheck.Type &&
                                               <div
                                                 className={classNames('top4', {
                                                   'purple':DeterministicQualityCheck.Type == config.deterministicQualityCheckTypes.Base,
                                                   'orange':DeterministicQualityCheck.Type == config.deterministicQualityCheckTypes.ShowFirst
                                               })}>{DeterministicQualityCheck.Type}</div>
                                             }
                                           </div>;}}}
                                       dataAlign="center"dataSort={true}>Item Number</TableHeaderColumn>

                    <TableHeaderColumn width="20px" dataAlign="center" dataField='Matching'
                                       dataFormat={ customFormatter } formatExtraData={ {
                        path: ['MatchingType'] , format: (value, arg2) => {
                            return _.startCase(value)
                        }
                    }}        dataSort={true}>Matching</TableHeaderColumn>
                    <TableHeaderColumn width="30px"   dataFormat={this.formatCategories.bind(this)} dataField='Categories' dataAlign="center"
                                       dataSort={true}>Categories</TableHeaderColumn>
                    <TableHeaderColumn width="30px"  formatExtraData={ {'field': 'CategoryTags' } } dataFormat={this.formatTags.bind(this)} dataField='CategoryTags' dataAlign="center"
                                       dataSort={true}>Category Tags</TableHeaderColumn>
                    <TableHeaderColumn width="30px"   dataFormat={this.formatModels.bind(this)} dataField='Models' dataAlign="center"
                                       dataSort={true}>Models</TableHeaderColumn>
                    <TableHeaderColumn width="60px"    columnClassName={  'table-cell-with-image' } dataFormat={this.formatTextColumn.bind(this)}   dataAlign="center"dataSort={true}>Text</TableHeaderColumn>
                    <TableHeaderColumn width="20px" dataField='Status' dataAlign="center"dataSort={true}>Status</TableHeaderColumn>
                    <TableHeaderColumn width="40px" dataAlign="center" columnClassName={'break-word'}  dataField='SellerInventoryOwnership'
                                       dataFormat={ customFormatter } formatExtraData={ {
                        path: ['getObject'], format: (row, arg2) => {
                           return <div>
                               {_.isArray(row.SellerInventoryOwnership) &&  <div>{_.map(row.SellerInventoryOwnership, item=>{
                               return <div>{ _.get(_.find(config.inventoryOwnershipMap, {value: item}), 'label','')}</div>
                           })}</div>}
                                   {_.find(_.get(row,'OverrideMatchingConditions',[]), {Type:'SellerInventoryOwnership'}) &&
                                   <div className="top10 orange">Always displayed for these seller types</div>
                                   }
                           </div>
                        }
                    }}  dataSort={true}>Seller Type</TableHeaderColumn>
                   <TableHeaderColumn width="50px" dataAlign="center" columnClassName={'break-word'}  dataField='Data'
                    dataFormat={ customFormatter } formatExtraData={ {
                    path: ['Rules'] , format: (value, arg2) => {
                        if (_.size(value)>0) {
                            return JSON.stringify(value)
                        }
                    }
                    }}  dataSort={true}>Rules</TableHeaderColumn>

                    <TableHeaderColumn dataField="_id" isKey={true} hidden={true} autoValue={ true }
                                       hiddenOnInsert>Id</TableHeaderColumn>
                    <TableHeaderColumn   width="20px" dataAlign="center"  columnClassName={'actions-column'}
                                       editable={ false }
                                       dataFormat={ this.customActionsFormatter.bind(this) }>Actions</TableHeaderColumn>
                </BootstrapTable>

            </div>
        );
    }
}


export default AdminQualityChecksListTable;
